<div
  #trigger="opacPopoverTrigger"
  class="select"
  [class.open]="isOpen()"
  [opacPopoverTriggerMaxHeight]="530"
  [opacPopoverTriggerMaxWidth]="500"
  [opacPopoverTrigger]="popover"
  [opacPopoverTriggerCancelHostInteraction]="true"
  [opacPopoverTriggerPosition]="popoverPosition"
  [opacPopoverTriggerBeforeMiddlewares]="popoverBeforeMiddlewares"
  [opacPopoverTriggerAfterMiddlewares]="popoverAfterMiddlewares"
  (popoverOpen)="handlePopoverOpen()"
  (popoverClose)="handlePopoverClose()"
>
  <opac-text-input
    #textInput
    (keydown)="handleKeyDown($event)"
    (input)="handleInput($event)"
    (blur)="handleBlur()"
    (click)="toggleMenu()"
    [ariaAutocomplete]="multiple ? 'list' : 'none'"
    [ariaActiveDescendant]="focusedOption()?.id ?? ''"
    [ariaControls]="popoverId"
    [ariaExpanded]="isOpen()"
    ariaHasPopup="listbox"
    [autofocus]="autofocus"
    [disabled]="isDisabled"
    icon="expand_more"
    [id]="id"
    [invalid]="invalid"
    [readonly]="!multiple"
    [required]="required"
    role="combobox"
    [ngModel]="displayValue()"
  >
    <ng-content></ng-content>
    <ng-content select="[slot='error']" slot="error"></ng-content>
  </opac-text-input>

  <opac-popover #popover [id]="popoverId" [ariaLabelledBy]="id + '-label'" [attr.aria-multiselectable]="multiple" role="listbox">
    <ng-content select="opac-option"></ng-content>
  </opac-popover>
</div>
